import CheckoutCard from '../CheckoutCard';
import OrderItem from './OrderItem';
import SubmitButton from './SubmitButton';
import { useCurrentOrderQuery } from '@/hooks/queries/use-order-query';
import useCartStore from '@/stores/cart.store';

export default function OrderSummaryCheckoutCard() {
  const { data: order } = useCurrentOrderQuery();
  const cartItems = useCartStore((state) => state.items);

  return (
    <CheckoutCard className="h-full" isAvailable={Boolean(order?.customer)} key={OrderSummaryCheckoutCard.name}>
      <div className="text-gray-800 dark:text-gray-100 font-semibold mb-2">Din beställning</div>
      <div className="flex flex-col justify-between h-[90%]">
        {/* Cart items */}
        <ul>
          {order?.orderItems?.map((item) => (
            <OrderItem
              key={item.productId}
              id={item.productId}
              name={item.productName ?? ''}
              quantity={item.quantity}
              price={item.unitPrice ?? { amount: 0, currency: 'SEK' }}
              thumbnail={cartItems.find((c) => c.id === item.productId)?.thumbnail}
            />
          ))}
        </ul>
        <SubmitButton />
      </div>
    </CheckoutCard>
  );
}
